(function () {
  'use strict';

  /* @ngdoc object
   * @name crewValidation
   * @description
   *
   */
  angular
    .module('crewValidation', [
      'ui.router'
    ]);
}());
